export const autosaveTiming = 1000; // 1 seg
export const autosaveTimingApplicantIntake = 1000; // 5 seg
export const autosaveTimingDocument = 2000; // 1 seg
export const autosaveTimingClaimForm = 1000; // 1 seg
